
import { IStandardNavigationState, MenuItem } from "./standardNavigation.t";
import { MutationTree } from "vuex";
import { MutationTypesStandardNavigation } from "./types";
import { PlacementTypes } from "@/libs/graphics/types/Graphics.t";
/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */

export interface UpdateStandardNavigationPayload extends Omit<IStandardNavigationState, 'menu'> {
  menu: MenuItem[]
}

export type MutationsStandardNavigation<S = IStandardNavigationState> = {
  [MutationTypesStandardNavigation.SET_STANDARD_NAVIGATION](state: S, payload: UpdateStandardNavigationPayload): void
  [MutationTypesStandardNavigation.UPDATE_STANDARD_NAVIGATION](state: S, payload: IStandardNavigationState): void
  [MutationTypesStandardNavigation.UPDATE_MENU_STANDARD_NAVIGATION](state: S, payload: IStandardNavigationState): void
  [MutationTypesStandardNavigation.SET_ACTIVE_COMPONENT_STANDARD_NAVIGATION](state: S, payload: PlacementTypes): void
  [MutationTypesStandardNavigation.SET_LAST_COMPONENT_SWATCH_APPLIED](state: S, payload: string): void
  [MutationTypesStandardNavigation.SET_PREVIOUS_COMPONENT](state: S, payload: string): void
  [MutationTypesStandardNavigation.IS_STANDARD_MENU_OPEN](state: S, payload: boolean): void
  [MutationTypesStandardNavigation.IS_PREVIOUS_MENU_STATE_OPEN](state: S, payload: boolean): void
}

const mutations: MutationTree<IStandardNavigationState> & MutationsStandardNavigation = {

  [MutationTypesStandardNavigation.SET_STANDARD_NAVIGATION](state, payload) {
    state.activeComponent = payload.activeComponent;
    state.activeSubComponent = payload.activeSubComponent;
    state.menu = payload.menu;
  },

  [MutationTypesStandardNavigation.UPDATE_STANDARD_NAVIGATION](state, payload) {
    state.activeComponent = payload.activeComponent;
    state.activeSubComponent = payload.activeSubComponent;
    state.menu = payload.menu;
  },

  [MutationTypesStandardNavigation.UPDATE_MENU_STANDARD_NAVIGATION](state, { menu, item }) {
    if (menu){
      state.menu = menu;
    } else if (item) {
      const tmpMenu = [...state.menu];
      const itemPosition = tmpMenu?.findIndex(menuItem => menuItem.id === item.id);
      if (itemPosition >= 0) {
        tmpMenu[itemPosition] = { ...tmpMenu[itemPosition], ...item };
        state.menu = tmpMenu;
      }
    }
  },

  [MutationTypesStandardNavigation.SET_ACTIVE_COMPONENT_STANDARD_NAVIGATION](state, payload) {
    state.activeComponent = payload;
    state.activeSubComponent = !!state.activeSubComponent? state.activeSubComponent: '';
  },

  [MutationTypesStandardNavigation.SET_LAST_COMPONENT_SWATCH_APPLIED](state, payload) {
    state.lastComponentSwatchApplied = payload;
  },

  [MutationTypesStandardNavigation.SET_PREVIOUS_COMPONENT](state, payload) {
    state.previousComponent = payload;
  },

  [MutationTypesStandardNavigation.IS_STANDARD_MENU_OPEN](state, payload){
    state.isStandardMenuOpen = payload
  },

  [MutationTypesStandardNavigation.IS_PREVIOUS_MENU_STATE_OPEN](state, payload){
    state.isPreviousMenuStateOpen = payload
  },
};

export default mutations;
